var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7802 23.1044C43.7802 28.9637 39.0822 33.662 33.2187 33.662C27.3571 33.662 22.6572 28.9637 22.6572 23.1044C22.6572 17.245 27.3571 12.5487 33.2187 12.5487C39.0822 12.5487 43.7802 17.245 43.7802 23.1044ZM33.2183 52.4485C24.5647 52.4485 17.2583 51.042 17.2583 45.6156C17.2583 40.1872 24.6106 38.8305 33.2183 38.8305C41.8739 38.8305 49.1783 40.237 49.1783 45.6635C49.1783 51.0919 41.826 52.4485 33.2183 52.4485Z",
    fill: "#200E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5019 17.3947L18.1147 46.7819",
    stroke: "#EB0909",
    strokeWidth: 5.47995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5094 46.7966L18.0977 17.3788",
    stroke: "#EB0909",
    strokeWidth: 5.47995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71826 18.6691V3.38C1.71826 2.06556 2.78382 1 4.09826 1H18.7508M1.71826 46.5779V61.62C1.71826 62.9344 2.78382 64 4.09826 64H18.7508M63.2818 18.6691V3.38C63.2818 2.06556 62.2162 1 60.9018 1H47.2753M63.2818 46.5779V61.62C63.2818 62.9344 62.2162 64 60.9018 64H47.2753",
    stroke: "#EB0909",
    strokeWidth: 1.83912
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFaceIcon);
export default __webpack_public_path__ + "static/media/noFaceIcon.e2c53457.svg";
export { ForwardRef as ReactComponent };